<template>
    <v-content>
        <router-view></router-view>
        <v-snackbar
                v-model="showNewUpdateMessage"
                :top="true"
                :timeout="10000"
                v-show="showNewUpdateMessage"
        >
            {{newUpdate.text}}
            <v-btn
                    color="pink"
                    flat
                    @click="reloadPage"
            >
                Recargar
            </v-btn>
        </v-snackbar>
    </v-content>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'AppView',
    computed: {
      ...mapState({
        newUpdate: store => store.app.newUpdate,
        showNewUpdateMessage: store => store.app.showNewUpdateMessage
      })
    },
    methods: {
      reloadPage () {
        window.location.reload()
      }
    }
  }
</script>

<style>
    @media only screen and (max-width: 599px) {
        .container {
            padding: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/core/AppView.vue